module.exports = __webpack_public_path__ + "static/media/fdg-mcc.4f253634.png";